import { Ref, ref } from '@vue/composition-api';
import type { plTooltip as PlTooltip } from '@ks/platform-ui';
type TipType = 'share' | 'more';

export function useTip() {
    const shareTip: Ref<InstanceType<typeof PlTooltip> | null> = ref(null);
    const moreTip: Ref<InstanceType<typeof PlTooltip> | null> = ref(null);
    function toolTipShow(type: TipType) {
        if (type === 'share') {
            shareTip.value.positionInfo.top = shareTip.value.positionInfo.top - 62;
            shareTip.value.positionInfo.left = shareTip.value.positionInfo.left + 2;
        } else {
            moreTip.value.positionInfo.top = moreTip.value.positionInfo.top - 62;
            moreTip.value.positionInfo.left = moreTip.value.positionInfo.left + 2;
        }
    }
    return {
        shareTip,
        moreTip,
        toolTipShow,
    };
}